export {default} from './DateJoined.connect';
